import BaseComponent from '@/components/base';
import Style from '@/components/feature-list-banner/style';
import { FontStyle } from '@/components/style';
import $ from 'jquery';
import 'slick-carousel';

export default class FeatureListBanner extends BaseComponent {
  afterMount() {
    this.slider = this.shadowRoot.querySelector('.collection-text-slider');
    this.setupSlider();
  }

  setupSlider() {
    if (this.slider) {
      $(this.slider).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    } else {
      console.error('Slider element not found.');
    }
  }

  get headline() {
    return this.getAttribute('headline');
  }

  get subheadline() {
    return this.getAttribute('subheadline');
  }

  get features() {
    return JSON.parse(this.getAttribute('features'));
  }

  render() {
    return `
    ${Style}
    ${FontStyle}
    <section class="feature-list-container">
      <div class="feature-list-container__wrapper">
        <div class="feature-list-container__text">
          <p class="feature-list-container__headline">${this.headline}</p>
          <p class="feature-list-container__subheadline">${this.subheadline}</p>
        </div>
      </div>
      <div class="slider-container drag-to-scroll">
        <div class="collection-text-slider">
          ${this.features
            .map((feature) => {
              return `
              <div class="text feature-list-container__slide slick">
                <p class="body-font-4 feature-text">${feature.text}</p>
              </div>
            `;
            })
            .join('')}
        </div>
      </div>
    </section>`;
  }
}
